// 빌드 시 vite.config.js 의 define 으로 주입되는 글로벌 상수.
// run.env (= 단일 진실 소스) 를 읽어 Vite 가 빌드 타임에 채운다.
// 하드코딩 회피 — 신규 환경/저장소 기본값은 run.env 만 수정하면 된다.

const FALLBACK = {
  storage_type:  'firestore',
  gcs_path:      '',
  fs_project:    '',
  fs_database:   'kb-agent',
  // root collection 명 — sub-collection 'semantic_views' 와 혼동 금지.
  // 정상 path: '{fs_collection}/{user_scope}/semantic_views/{sv_name}'
  fs_collection: 'semantic_view_artifacts',
  project_id:    '',
  location:      'asia-northeast3',
  model_name:    'gemini-2.5-flash',
}

// eslint-disable-next-line no-undef
export const APP_DEFAULTS = (typeof __APP_DEFAULTS__ !== 'undefined')
  // eslint-disable-next-line no-undef
  ? { ...FALLBACK, ...__APP_DEFAULTS__ }
  : FALLBACK

// Gemini 모델 후보 — 메타 설정 datalist 제안 + '전체 확인' 대상 (자유 입력도 허용).
// 2026-07 실측(Vertex global endpoint) 기준 사용 가능 목록 —
// 리전에 따라 가용성이 다르므로(예: asia-northeast3 은 2.5-flash 만) 최종 판단은
// 메타 설정의 '✓ 확인'/'전체 확인'(실제 호출 검증)으로 한다. 새 모델 출시 시 여기만 갱신.
export const GEMINI_MODEL_CANDIDATES = [
  'gemini-3-flash-preview',
  'gemini-2.5-flash',
  'gemini-2.5-pro',
  'gemini-2.5-flash-lite',
]
